import React, { useState, useEffect, useCallback } from "react";
// import styled from "styled-components";
import { useTable, usePagination, useSortBy } from "react-table";
import {
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";

function TableView({ columns, data,customPageSize ,sumhours,sumbillable,estimated,onchangeApprovestatus,curstatus,handleSubmit,handleChange,curstatusList,disablePagination}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    rows,
    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      
      defaultCanSort: true,
      initialState: { pageIndex: 0 ,
        sortBy: [{ id: "Name", asc: true }]},
    },
    useSortBy,
    usePagination
  );
useEffect(() => {
  if (customPageSize) setPageSize(customPageSize);
}, [setPageSize, customPageSize]);
// decide which data to render
  const displayedRows = disablePagination ? rows : page; // 👈 switch based on flag

  let optionselect=[];
  optionselect.push({value :0 ,label:"Select"},{value :1 ,label:"Approve"},{value :2 ,label:"Reject"})
  // Render the UI for your table
  return (
    <>
   {!disablePagination && (<Row className="mb-2" id="showPageCountInTable">
           <Col sm={2}>
             <select
               className="form-control"
               value={pageSize}
               onChange={(e) => {
                 setPageSize(Number(e.target.value));
               }}
               // style={{ width: "140px" }}
             >
               {[5, 10, 20, 30, 40, 50].map((pageSize) => (
                 <option key={pageSize} value={pageSize}>
                   Show {pageSize}
                 </option>
               ))}
             </select>
           </Col>
         </Row>)}
  <div
  className="main-div"

>
          <Table hover {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup, p) => (
                <tr key={p} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                   
                    >
                      {/* Add a sort direction indicator */}
                      <span className="">
                        {column.render("Header")}

                       
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
  {(disablePagination ? rows : page).map((row, i) => {
    prepareRow(row);
    return (
      <tr key={i} {...row.getRowProps()}>
        {row.cells.map((cell, k) => (
          <td key={k} {...cell.getCellProps()}>
            {cell.render("Cell")}
          </td>
        ))}
      </tr>
    );
  })}
</tbody>

          </Table>
        </div>
      <Row className="table-pagination">
              <Col>
                {!disablePagination && (<Pagination
                  // size="sm"
                  aria-label="Page navigation example"
                  className="pagination"
                >
                  <PaginationItem>
                    <PaginationLink
                      first
                      onClick={() => gotoPage(0)}
                      disabled={!canPreviousPage}
                    />
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      previous
                      onClick={() => previousPage()}
                      disabled={!canPreviousPage}
                    />
                  </PaginationItem>
                  &nbsp;
                  <strong className="mt-1">
                    {pageIndex + 1} of {pageOptions.length}
                  </strong>
                  &nbsp;
                  <PaginationItem>
                    <PaginationLink
                      next
                      onClick={() => nextPage()}
                      disabled={!canNextPage}
                    />
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      last
                      onClick={() => gotoPage(pageCount - 1)}
                      disabled={!canNextPage}
                    />
                  </PaginationItem>
                </Pagination>)}
      
              </Col>
              <Col>
                <Row className="table-goto-page">
                  <Col sm={12} xs={6} md={7} lg={12}>
                    <div
                      className="input-group mb-3 float-right"
                      style={{ width: "180px" }}
                    >
                      <div className="input-group-prepend">
                        <label className="input-group-text">Go to page</label>
                      </div>
                      <input
                        className="form-control"
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={(e) => {
                          const page = e.target.value
                            ? Number(e.target.value) - 1
                            : 0;
                          gotoPage(page);
                        }}
                      />
                    </div>
                 
                  </Col>
                  {/* <Col sm={4} xs={6} md={5} lg={4}></Col> */}
                </Row>
              </Col>
            </Row>
    </>
  );
}


const TableWithSorPagtn = React.memo((props) => {

  const { thead } = props;
  
  const columns = React.useMemo(
    () =>
      thead.map((el, i) => {
        return { Header: el, accessor: el };
      }),
    [thead]
  );
  const data = React.useMemo(() => props.trow, [props.trow]);
  return (
    // <Styles>

    <TableView columns={columns} data={data} customPageSize={10} sumhours={props.sumhours} sumbillable={props.sumbillable} estimated={props.estimated} onchangeApprovestatus={props.onchangeApprovestatus} curstatus={props.curstatus} handleSubmit={props.handleSubmit} handleChange={props.handleChange} curstatusList={props.curstatusList} disablePagination={props.disablePagination}/>
    // </Styles>
  );
});

export default TableWithSorPagtn;
